// Configuración de la API
export const API_CONFIG = {
  // URL base de la API (backend FastAPI)
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  
  // Endpoints de autenticación
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    ME: '/api/auth/me'
  },
  
  // Endpoints de Cicla
  CICLA: {
    INVOICES: '/api/cicla/invoices',
    STATS: '/api/cicla/stats',
    INVOICE_DETAIL: '/api/cicla/invoices',
    DOCUMENTO_DETALLE: '/api/cicla/documento',
    NDC_BUSCAR: '/api/cicla/ndc/buscar',
    NDC_EMITIR_LOTE: '/api/cicla/ndc/emitir-lote',
    PENDIENTES_LIST: '/api/cicla/pendientes',
    PENDIENTES_ACTUALIZAR_LOTE: '/api/cicla/pendientes/actualizar-lote',
  },

  // Endpoints de Reportes
  REPORTES: {
    DBA_AUDIT_TRAIL: '/api/reportes/dba-audit-trail',
    DBA_AUDIT_TRAIL_EXPORT: '/api/reportes/dba-audit-trail/export',
    DBA_AUDIT_TRAIL_USUARIOS: '/api/reportes/dba-audit-trail/usuarios',
    DBA_AUDIT_TRAIL_SEND_EMAIL: '/api/reportes/dba-audit-trail/send-email',
  },

  // Endpoints de Clientes
  CLIENTES: {
    LIST: '/api/clientes',
    CREATE: '/api/clientes',
    UPDATE: '/api/clientes',
    DELETE: '/api/clientes',
    GET_BY_ID: '/api/clientes',
    EXONERACIONES: '/api/clientes', // Base path for exoneraciones
    EXONERACIONES_BY_CLIENTE: '/api/clientes/{cliente_id}/exoneraciones', // Get exoneraciones by cliente
    EXONERACIONES_CRUD: '/api/clientes/exoneraciones' // CRUD operations for exoneraciones
  }
};

// Función para construir URLs completas
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Configuración de axios
export const axiosConfig = {
  baseURL: API_CONFIG.BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
}; 